import { z } from "zod";

export const customerRowSchema = z.object({
    CustomerNumber: z.string(),
    Name: z.string(),
    City: z.string(),
});

export const farmRowSchema = z.object({
    CustomerNumber: z.string(),
    FarmLicenseKey: z.string(),
    Name: z.string(),
    City: z.string(),
});

export const deviceCategorySchema = z.enum(["Astronaut", "Juno", "Discovery", "Other"]);

export const deviceRowSchema = z.object({
    CustomerNumber: z.string(),
    CustomerName: z.string(),
    CustomerCity: z.string(),
    DeviceSerialNumber: z.string(),
    DeviceCategory: deviceCategorySchema,
    DeviceType: z.string(),
});

export const technicianRowSchema = z.object({
    TechnicianCode: z.string(),
    Name: z.string().nullable(),
});

export const partRowSchema = z.object({
    PartNumber: z.string(),
    PartDescription: z.string(),
});

export const customerExtendedRowSchema = customerRowSchema.extend({
    devices: z.array(deviceRowSchema),
    farms: z.array(farmRowSchema),
});

export const searchCategorySchema = z.enum(["all", "customer", "farm", "device", "technician", "part"]);

export const searchResultsSchema = z.object({
    customers: z.array(customerExtendedRowSchema),
    devices: z.array(deviceRowSchema),
    farms: z.array(farmRowSchema),
    technicians: z.array(technicianRowSchema),
    parts: z.array(partRowSchema),
});

export const searchResultItemSchema = z.intersection(
    z.object({
        sortValue: z.string(),
    }),
    z.discriminatedUnion("type", [
        z.object({
            type: z.literal("customer"),
            data: customerRowSchema,
        }),
        z.object({
            type: z.literal("customerExtended"),
            data: customerExtendedRowSchema,
        }),
        z.object({
            type: z.literal("farm"),
            data: farmRowSchema,
        }),
        z.object({
            type: z.literal("device"),
            data: deviceRowSchema,
        }),
        z.object({
            type: z.literal("technician"),
            data: technicianRowSchema,
        }),
        z.object({
            type: z.literal("part"),
            data: partRowSchema,
        }),
    ]),
);
